<template>
  <div>
    <div class=" mainLoader" v-if="loading">
    </div>
    <div class="col-md-12 company-detail-image">
    </div>
    <div class="realbody">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="row mt-3">
              <div class="col-md-2" style="text-align: center;">
                <div class="imgpanel mb-1">
                  <video v-if="company_video"   height="150" width="150" controls autoplay loop>
                    <source :src="company_video">
                  </video>
                  <img v-if="company_image" class="avatar"  :src="company_image" />
                </div>
              </div>
              <div class="col-md-10" style="margin-top: 80px;">
                <div class="row">
                  <div class="col-md-12">
                        <h3 class="rc_firsttitle mplus2p-m spacing0-7 noiseblack">{{company_name}}</h3>
                  </div>
                  <div v-if="!testUser && interview_completed" class="col-md-12">

                    <button class="btn whitebtn clickcbtn" :class="{like : cmp_list.pivot }"  @click="onFavClickCompany(cid)" style="margin-right: 10px;">
                      <i class="fa fa-heart margin-r-5"></i>
                    </button>

                    <button v-if="company_user_count == 0" class="btn whitebtn clickcbtn" disabled @click="sandMsg(cid)" style="margin-right: 10px;">
                        <i class="fa fa-envelope margin-r-5"></i>
                      </button>
                      <button v-if="company_user_count > 0" class="btn whitebtn clickcbtn"  @click="sandMsg(cid)" style="margin-right: 10px;">
                        <i class="fa fa-envelope margin-r-5"></i>
                      </button><div v-if="want_to_talk_casually" class="casually">{{$t('speech_bubble')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
              <div class="row">
                <div v-if="company_manager_comments" class="comment-block">
                  <p class="comment-title">{{$t('comments_manager')}}</p>
                  <p class="comment-desc">{{company_manager_comments}}</p>
                </div>
              </div>
            </div>
          <div v-if="company_desc" class="col-md-12" style="margin-top: 10px;">
            <h3 class="rc_firsttitle mplus2p-m spacing1-2 noiseblack">{{$t('cp_company_desc')}}</h3>
            <div style="height: 20px;">
              <hr style="border-width: 2px; border-color: #3d7dd8; width: 20%; float: left;" />
              <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
            </div>
            <pre class="mplus2p-m rc_firstcontent noiseblack" style="height: auto;white-space:pre-wrap;-webkit-box-orient: vertical" v-html="urlify(company_desc)"></pre>
          </div>

          <div v-if="!testUser" class="col-md-12" style="margin-top: 40px;">
            <h3 class="rc_firsttitle mplus2p-m spacing1-2 noiseblack">{{$t('cd_recruit')}}</h3>
              <div style="height: 20px;">
              <hr style="border-width: 3px; border-color: #3d7dd8; width: 20%; float: left;" />
              <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
            </div>
          </div>

          <div class="col-md-12" style=" margin-bottom: 30px">
            <div class="ceboxes mplus2p-m rc_firstcontent text-center" v-if="recruit_list == 0">
              <div class="alert alert-danger">
                <strong>{{$t('err_recruitAvailable')}} </strong>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 mb-3" v-for="(recruit,index) of recruit_list" :key="index">
                <div class="ceboxes" v-if="recruit_list != '' ">
                  <div class="row" >
                    <div class="col-md-12 mb-2" style="text-align: left;">
                      <router-link :to="{ name: 'companyRecuritDetail', params: {rid: recruit.id} }" target="_blank">
                        <p class="ctitle mplus2p-m spacing1-2 noiseblack">{{recruit.subject}}</p>
                      </router-link>
                      <hr class="cline"/>
                      <p class="ccontents mplus2p-m spacing1-2 noiseblack" style="height: auto;white-space:pre-wrap;-webkit-box-orient: vertical">{{recruit.content}}
                      </p>
                      <div v-if="recruit.manager_comments" class="comment-block2">
                        <p class="comment-title">{{$t('comments_manager')}}</p>
                        <p class="comment-desc">{{recruit.manager_comments}}</p>
                      </div>
                    </div>
                    <div v-if="!testUser && interview_completed" class="col-md-12 text-right">
                      <button class="btn whitebtn clickcbtn" :class="{like : recruit.pivot }"  @click="onFavClick(recruit.id,index)" style="margin-right: 10px;">
                        <i class="fa fa-heart margin-r-5"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="company_benefites != ''" class="col-md-12" style="margin-top: 20px;">
            <h3 class="rc_firsttitle mplus2p-m spacing1-2 noiseblack">{{$t('benefit')}}</h3>
            <div style="height: 20px;">
              <hr style="border-width: 2px; border-color: #3d7dd8; width: 20%; float: left;" />
              <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
            </div>
            <div class="tech2">
                  <span class="layer2" v-for="(item, index) of company_benefites" :key="index">{{ lan == 'en'? item.en_benefit:item.jp_benefit}}</span>
            </div>
          </div>

          <div class="col-md-12" style="margin-top: 40px; margin-bottom: 30px">
            <h3 class="rc_firsttitle mplus2p-m spacing1-2 noiseblack">{{$t('cd_about')}}</h3>
            <div style="height: 20px;">
              <hr style="border-width: 2px; border-color: #3d7dd8; width: 20%; float: left;" />
              <hr style="border-width: 2px; border-color: #f8fafa; width: 80%; float: left;" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="row">
              <div class="col-md-4">
                <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_name')}}</p>
              </div>
              <div class="col-md-8">
                <p class="mplus2p-m spacing1-2 noiseblack">{{company_name}}</p>
              </div>
              <template v-if="company_location">
                <p style="height: 40px;"></p>
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_location')}}</p>
                </div>
                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{company_location}}</p>
                </div>
              </template>

              <template v-if="company_esablishment">
                <p style="height: 40px;"></p>
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_establishment')}}</p>
                </div>
                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{company_esablishment}}</p>
                </div>
              </template>

              <template v-if="company_representative">
                <p style="height: 40px;"></p>
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_representative')}}</p>
                </div>
                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{company_representative}}</p>
                </div>
              </template>

              <template v-if="company_enterprise_url">
                <p style="height: 40px;"></p>
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_e_url')}}</p>
                </div>
                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack link" @click="navigateToUrl(company_enterprise_url)">{{company_enterprise_url}}</p>
                </div>
              </template>

              <template v-if="company_NOE">
                <p style="height: 40px;"></p>
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('cp_noe')}}</p>
                </div>
                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{company_NOE}}</p>
                </div>
              </template>

              <template v-if="company_recruitment_situation">
                <p style="height: 40px;"></p>
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('recruitment_situation')}}</p>
                </div>
                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{lan == 'en' ? company_recruitment_situation.en_situation : company_recruitment_situation.jp_situation}}</p>
                </div>
              </template>

              <template v-if="company_engineer_ratio">
                <p style="height: 40px;"></p>
                <div class="col-md-4">
                  <p class="pgraytxt mplus2p-m spacing1-2 noiseblack pvlabel">{{$t('ratio_of_engineer')}}</p>
                </div>
                <div class="col-md-8">
                  <p class="mplus2p-m spacing1-2 noiseblack">{{lan == 'en' ? company_engineer_ratio.en_ratio : company_engineer_ratio.jp_ratio}}</p>
                </div>
              </template>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div :class="{'d-none' : !company_lat && !company_long}" id="map">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hashids from "hashids";
import axios from "axios";
import { EventBus } from "../../main.js";
import { validationMixin } from "vuelidate";
import Swal from 'sweetalert2/dist/sweetalert2.js'
export default {
  mixins: [validationMixin],
  data() {
    return {
      window_width: "",
      place: "india",
      recruit_list: [],
      favorite_recruit: [],
      interview_completed: '',
      testUser:0,

      userId: "",

      company_name: "",
      company_image: "",
      company_video: "",
      company_manager_comments: '',
      company_location: "",
      company_esablishment: "",
      company_representative: "",
      company_person_in_charge: "",
      company_enterprise_url: "",
      company_NOE: "",
      company_job_category: "",
      company_engineer_experience: "",
      company_desc: "",
      company_idea: "",
      company_vision: "",
      company_recruitment_situation : '',
      company_engineer_ratio: '',
      company_benefites: '',
      company_user_count: '',
      loading: false,

      userToken: "",
      job_seeking: [],
      popupDisplay : false,
      want_to_talk_casually:'',

      map: {},
      company_lat: 0,
      company_long: 0,

      company_favorite: [],
      cmp_list: {},
      cid: "",
      lan: "jp"
    };
  },
  mounted() {
     if (localStorage.getItem("role") == "engineer") {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.userId = data.id;
      this.userToken = data.user_token;
      this.testUser = data.test_user;
      this.interview_completed = data.completed_interview;
      this.job_seeking = data.job_seeking_situation;
    }
    this.window_width = $(window).width() + 17; //default
    this.showorhide();

    this.companyDetail(this.cid);
     EventBus.$on("language", data => {
      this.lan = data;
    });
  },
  created() {
    if ("lan" in localStorage) {
      this.lan = localStorage.getItem("lan");
    }
    var hashids = new Hashids("CompanyIds", 8, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890")
    var companyId = hashids.decode(this.$route.params.cid)
    if (companyId.length == 0) {
       return this.$router.push("/global/PageNotFound");
    }
    this.cid = companyId[0];
  },
  methods: {
     urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      //var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function(url,b,c) {
          var url2 = (c == 'www.') ?  'http://' +url : url;
          return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
      })
    },
    sandMsg(cid) {
      var hashids = new Hashids("this is my salt", 8, "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890");
      this.$router.push("/global/chatroom/"+ hashids.encode(cid));
    },
     initMap() {
            // The location of Uluru
            var uluru = {lat: this.company_lat, lng: this.company_long};
            // The map, centered at Uluru
            var map = new google.maps.Map(
                document.getElementById('map'), {zoom: 14, center: uluru}
            );
            var marker = new google.maps.Marker({position: uluru, map: map, draggable:false});
            // The marker, positioned at Uluru
        },
    onFavClickCompany(id) {
       var vm = this;
      if (this.popupDisplay) {
        this.favCompamy(id);
        const swalWithBootstrapButtons = Swal.mixin({
          confirmButtonClass: "btn btn-primary inquiry",
          cancelButtonClass: "btn btn-success change",
          buttonsStyling: false
        });

        swalWithBootstrapButtons({
         html:
            vm.$t("pop_up_title") +' <b style="color:black;font-weight:700">' +
            (!this.job_seeking ? vm.$t('pop_up_unselected') :
            (this.lan == "en"
              ? this.job_seeking.en_situation
              : this.job_seeking.jp_situation)) +
            "</b>. " +
            '<span style="font-size: 16px !important">'+vm.$t("pop_up_it_ok")+'</span>',
          type: "info",
          showCancelButton: true,
          showConfirmButton: this.job_seeking ? true : false,
          confirmButtonText: vm.$t("pop_up_ok"),
          cancelButtonText: vm.$t("pop_up_change"),
          reverseButtons: false,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            axios
            .post(
              "/popup-display?token=" +
                localStorage.getItem("token"),
              { headers: { "X-localization": localStorage.getItem("lan") } }
            )
            .then(res => {
                vm.popupDisplay = false;
              })
              .catch(error => console.log(error));
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            axios
            .post(
              "/popup-display?token=" +
                localStorage.getItem("token"),
              { headers: { "X-localization": localStorage.getItem("lan") } }
            )
            .then(res => {
                vm.popupDisplay = false;
                  vm.$router.push({
                  name: "engineerProfileEdit",
                  params: { uid: this.userToken },
                  query: { page: 1 }
                });
              })
              .catch(error => console.log(error));
          }
        });
      } else {
          this.favCompamy(id);
      }
    },
    favCompamy(id){
      var token = localStorage.getItem("token");
      var vm = this;
      const formData = {
        company_id: id
      };
      this.cmp_list.pivot = !this.cmp_list.pivot;
      this.$forceUpdate();
      axios
        .post("/favorite/company?token=" + token, formData, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data.data.message) {
              this.$toaster.error(res.data.data.message);
              this.cmp_list.pivot = !this.cmp_list.pivot;
            }
          } else {
            if (res.data.liked) {
              this.$toaster.success(vm.$t("success_company_favorited"));
            } else {
              this.$toaster.error(vm.$t("err_company_favorited"));
            }
          }
        });
    },
    filterFavoriterCompany() {
      var index = this.company_favorite.findIndex(obj => {
        if (obj.pivot.company_id == this.cid) {
          return true;
        }
      });
      if (index != -1) {
        this.cmp_list = { pivot: true };
      } else {
        this.cmp_list = { pivot: false };
      }
      this.$forceUpdate();
    },
    getFavoriterCompany() {
      var token = localStorage.getItem("token");
      axios
        .get("/favorited/company?token=" + token)
        .then(res => {
          if (!res.data.result) {
            this.popupDisplay = res.data.popup_display;
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
          } else {
            this.popupDisplay = res.data.popup_display;
            this.company_favorite = res.data.companies.data;
            this.filterFavoriterCompany();
          }
        })
        .catch(error => console.log(error));
    },
    onFavClick(id, index) {
      let user = localStorage.getItem("user");
      var token = localStorage.getItem("token");
      var vm = this;
      const formData = {
        recruit_id: id
      };
      this.recruit_list[index].pivot = !this.recruit_list[index].pivot;
      this.$forceUpdate();
      axios.post("/favorite/recruit?token=" + token, formData).then(res => {
        if (!res.data.result) {
          if (res.data.data.message) {
            this.recruit_list[index].pivot = !this.recruit_list[index].pivot;
            this.$forceUpdate();
          }
        } else {
          if (res.data.liked) {
            this.$toaster.success(vm.$t("success_recruit_favorited"));
          } else {
            this.$toaster.error(vm.$t("err_recruit_favorited"));
          }
        }
      });
    },
    filterFavoriter() {
      for (var fav_rec of this.recruit_list) {
        var index = this.favorite_recruit.findIndex(obj => {
          if (
            obj.pivot.recruit_id == fav_rec.id &&
            obj.pivot.user_id == this.userId
          ) {
            return true;
          }
        });
        if (index != -1) {
          fav_rec.pivot = true;
        } else {
          fav_rec.pivot = false;
        }
      }
      this.$forceUpdate();
    },
    getFavoriter() {
      var token = localStorage.getItem("token");

      axios
        .get("/favorited/recruit?token=" + token)
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
          } else {
            var index = 1;
            for (var i = 0; i < res.data.recruits.data.length; i++) {
              this.favorite_recruit = res.data.recruits.data;
            }
            index++;
            this.filterFavoriter();
          }
        })
        .catch(error => console.log(error));
    },
    companyDetail(id) {
      this.loading = true;
      var token = localStorage.getItem("token");
      axios
        .get("company/detail/"+ id + "?token=" + token, {
          headers: { "X-localization": localStorage.getItem("lan") }
        })
        .then(res => {
          if (!res.data.result) {
            if (res.data[0]) {
              this.$toaster.error(res.data[0]);
              this.$store.dispatch("logout");
            }
            if(res.data.errors){
              for (var i = 0; i < res.data.errors.length; i++) {
                this.$toaster.error(res.data.errors[i].message);
                this.$router.push("/global/PageNotFound");
              }
            }
            this.loading = false;
          } else {
            this.loading = false;
            this.want_to_talk_casually = res.data.company.want_to_talk_casually;
            this.cid = res.data.company.id;
            this.company_name = res.data.company.name;
            if (res.data.company.image.split(/\#|\?/)[0].split('.').pop().trim() === 'mp4') {
              this.company_video = res.data.company.image
            }else{
              this.company_image = res.data.company.image
            }
            this.company_manager_comments = res.data.company.manager_comments;
            this.company_location = res.data.company.location;
            this.company_esablishment = res.data.company.establishment_year;
            this.company_representative = res.data.company.representative;
            this.company_person_in_charge = res.data.company.person_in_charge;
            this.company_enterprise_url = res.data.company.enterprise_url;
            this.company_recruitment_situation = res.data.company.recruitment_situation;
            this.company_engineer_ratio = res.data.company.ratio_of_engineer;
            this.company_benefites = res.data.company.benefits;
            this.company_job_category = res.data.company.job_category;
            this.company_user_count = res.data.company.users_count;
            this.company_engineer_experience =
              res.data.company.engineer_experience;
            this.company_NOE = res.data.company.number_of_employees;
            this.company_desc = res.data.company.company_description;
            this.company_idea = res.data.company.idea;
            this.company_vision = res.data.company.vision;
            this.company_lat = parseFloat(res.data.company.latitude.toFixed(7));
            this.company_long = parseFloat(res.data.company.longitude.toFixed(7));
            this.recruit_list = res.data.recruit_list.filter(obj => obj.recruitment_tension_id != 3);
            this.initMap();
            this.getFavoriter();
            this.getFavoriterCompany();
          }
        })
        .catch(error => console.log(error));
    },
    company_page(current_page) {
      this.$router.push({ query: { page: current_page } });
    },
    onResize(event) {
      this.window_width = $(window).width() + 17;
      this.showorhide();
    },

    showorhide() {
      if (this.window_width > 768) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      }
      if (this.window_width <= 768) {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },

    clicked_moreoption() {
      if ($(".options").hasClass("hider")) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      } else {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },
    navigateToUrl(url) {
      window.open(url, "_blank");
    }
  }
};
</script>

<style scoped>
.like .fa {
  color: #fc033b;
  text-shadow: 1px 1px 1px #ccc;
}
.casually{
  background: #3f7ed8;
  color: white;
  padding: 10px;
  border-radius: 6px;
  float: right;
  margin-right: 15px
}
.casually::after{
    content: '';
    position: absolute;
    right: 122px;
    width: 0;
    height: 0;
    border: 10px solid transparent;
    border-left-color: #3f7ed8;

}
.comment-block{
  width: 100%;
  border: 2px solid #3f7ed8;
  padding: 10px;
  border-radius: 20px;
  margin: 15px;
}
.comment-block2{
  width: 100%;
  border: 2px solid #3f7ed8;
  padding: 10px;
  border-radius: 20px;
}
.comment-title{
  color: #3f7ed8;
  font-size: 1rem;
  text-decoration: underline;
  margin-bottom: 5px;
}
.comment-desc{
  white-space: pre-line;
  word-break: break-all;
  font-size: 1rem;
  margin: 0;
  color: #3f7ed8;
}
.imgpanel {
  text-align: center;
  margin: auto;
}
.c_images {
    width: 100%;
    margin-top: 10px;
    height: 100px;
    border-radius: 3px;
  }
#map{
  width: 100%;
  height: 500px;
}
.tech2 {
  margin-right: 5px;
  margin-bottom: 10px;
}

.layer2 {
    border: 2px solid #3d7dd8;
    /* font-size: 1rem; */
    /* font-weight: 400; */
    font-style: normal;
    font-stretch: extra-condensed;
    letter-spacing: 0.4px;
    color: #3d7dd8;
    padding: 5px;
    margin-right: 5px;
    white-space: pre;
    word-break: keep-all;
    display: inline-block;
    border-radius: 11px;
    margin-bottom: 10px;
}
.link {
  cursor: pointer;
  color: blue;
}
.link:hover{
  text-decoration: underline;
}
.ctitle{
  margin-top: 7px;
  white-space: nowrap;
    overflow: hidden;
    display: block;
    text-overflow: ellipsis;
    word-wrap: break-word;
    text-align: justify;
}
/* .ctitle{

    margin-top: 7px;
} */
.ccontents{
  font-size: 0.825rem;
   display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: justify;
  word-break: break-all;
  text-overflow: ellipsis;
}
.company-detail-image {
  width: 100%;
  height: 110px;
}
.avatar {
  margin-top: 40px;
  width: 130px;
  height: 130px;
  object-fit: contain;
  object-position: center;
}
.realbody {
  margin-top: -40px !important;
}

.searchbox {
  height: 40px;
  border-radius: 4px;
  background-color: #f0f2f4;
  border: 1px solid #58606800;
}

.input-group-append {
  border-top-right-radius: 6.4px;
  border-bottom-right-radius: 6.4px;
  background-color: #3d7dd8;
}

.input-group-append button {
  color: white;
  border: 1px solid #58606800;
}

.input-group-append:hover button {
  color: #3d7dd8 !important;
}

.btn-outline-secondary:hover {
  background-color: white;
  color: #3d7dd8 !important;
}
.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  float: right;
}
.extxt {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(60, 80, 100, 0.8);
}

.checklabel {
  font-size: 0.8125rem;
  font-weight: 500;
}

.styled-checkbox + label:before {
  margin-right: 12px;
  margin-top: -2px;
}

.checkgrouplabel {
  font-size: 1rem;
  font-weight: 500;
}

.checkgrouppanel {
  margin-top: 45px;
}

.unstyled {
  margin-top: 13px;
}

.unstyled li {
  margin-top: 1px;
}

li:after {
  content: "\f107";
  font-family: FontAwesome;
  font-size: 22px;
  position: absolute;
  right: 30px;
  color: #6474847d;
  margin-top: -2px;
}

.rec_detail_title {
  font-size: 1.5rem;
  font-weight: 500;
}

.toppart {
  margin-top: 120px;
}

.smallcimg {
  width: 32px;
  height: 32px;
}

.comtitle {
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 15px;
}

.tagtip {
  height: 24px;
  color: white;
  padding: 5px;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 4px;
  margin-left: 10px;
}

.rec_top_first {
  margin-top: 30px;
}

.rec_top_second {
  margin-top: 25px;
}

.enrtybtn {
  width: 100%;
  height: 48px;
  border-radius: 24px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);
  font-size: 1rem !important;
}

.rc_firsttitle {
  font-size: 1.5rem;
  font-weight: 500;
}

.rc_firstcontent {
  font-size: 1rem;
  font-weight: 500;
  margin-top: 20px;
  line-height: 2;
  word-wrap: break-word;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

@media screen and (max-width: 400px) {
  .tagtip {
    float: right;
  }
}
</style>
